export const splitGutter = (gutter) => {
  const numericGutter = Number(gutter);
  return Number.isFinite(numericGutter) ? numericGutter / 2 : 0;
};
